<template lang="pug">
  v-layout(wrap class="pb-4")
    v-flex(xs12)
      h2(class="headline font-weight-bold pb-6") {{ typeTitle }}
      v-card(outlined style="border-radius:6px;" :loading="getAdvertLoading")
        v-card-title(class="pb-0")
          v-row(justify="center" no-gutters)
            v-col(cols="12" xs="12" sm="4" md="4" lg="2" class="pb-4",
              :class="$vuetify.breakpoint.mdAndDown ? 'pr-2' : 'mr-2'")
              v-select(
                v-if="this.type === this.advertType.COMMERCE",
                label="Тип рекламы",
                v-model="commerce",
                :items="commerceTypes",
                item-text="text",
                item-value="key",
                outlined,
                dense,
                hide-details)
              v-select(
                v-else
                label="Тип недвижимости",
                v-model="filters.items.Type",
                :items="buildingTypes",
                outlined,
                dense,
                hide-details)
            v-col(
              class="d-flex pb-4",
              :xs="$vuetify.breakpoint.xsOnly ? 12 : null",
              :sm="$vuetify.breakpoint.smAndDown ? 8 : null",
              :md="$vuetify.breakpoint.mdAndDown ? 8 : null",
              :class="$vuetify.breakpoint.mdAndDown ? 'pl-2' : 'mr-2'")
              v-text-field(
                class="mr-2",
                outlined,
                dense,
                mask="########",
                v-model="filters.items.PriceFrom",
                label="цена от",
                placeholder="0",
                hide-details)
              v-text-field(
                class="mr-2",
                outlined,
                dense,
                mask="########",
                v-model="filters.items.PriceTo",
                label="цена до",
                placeholder="0",
                hide-details)
              v-select(
                label="Валюта",
                v-model="filters.items.Currency",
                :items="currencyList",
                item-value="key",
                item-text="text",
                outlined,
                dense,
                hide-details)
            v-col(cols="12" xs="12" sm="6" md="6" lg="3" class="pb-4" :class="$vuetify.breakpoint.mdAndDown ? 'pr-2' : 'mr-2'")
              v-select(
                label="Територрия",
                v-model="filters.items.CityId",
                :items="cityList",
                item-value="id",
                item-text="text",
                outlined,
                dense,
                hide-details)
            v-col(cols="12" xs="12" sm="6" md="6" lg="3" class="pb-4")
              v-select(
                label="Районы",
                v-model="filters.items.DistrictId",
                :items="districtList",
                item-value="id",
                item-text="text",
                outlined,
                dense,
                hide-details)
          v-row(justify="space-between" align="center" class="px-3")
            div
              v-text-field(
                v-if="isDescriptionDisplay()",
                v-model="filters.items.description",
                class="mr-2 pb-4 d-inline-block",
                outlined,
                label="Поиск",
                placeholder="Например: магазин, склад",
                dense,
                clearable,
                style="width: 247px",
                hide-details)
              v-btn-toggle(
                v-model="filters.items.DurationRent",
                mandatory,
                class="duration mr-2 pb-4",
                v-if="isDurationRentDisplay()")
                v-btn(height=36, value="0") Все
                v-btn(height=36, value="longer") Длительная
                v-btn(height=36, value="daily") Посуточная
              v-btn-toggle(
                multiple,
                v-model="filters.items.RoomCount",
                class="duration pb-4 mr-2",
                v-if="isRoomsCountDisplay()")
                v-btn(height=36, value="0") Студия
                v-btn(height=36, value="1") 1
                v-btn(height=36, value="2") 2
                v-btn(height=36, value="3") 3
                v-btn(height=36, value="4") 4+
              v-btn-toggle(class="duration pb-4 mr-4" v-model="display" mandatory)
                v-btn(height=36, value="map") На карте
                v-btn(height=36, value="list") Список
            div(class="pb-4")
              v-btn(
                @click.prevent="getAdvertList(display)",
                color="#FFD54F",
                height="36") Показать {{ countAdverts }} #[span(class="text-lowercase") объявлений ]
        v-card-text
          v-row(justify="start" class="px-3")
            span(@click="isShow = !isShow" class="toggleBtn d-flex").
              Все параметры
                #[v-icon(small v-if="!isShow" color="#3D5AFE") keyboard_arrow_down]
                #[v-icon(small v-if="isShow" color="#3D5AFE") keyboard_arrow_up]
          transition(name="slide-fade")
            div
              div(v-if="isShow" class="pt-4").range-filters
                v-row(wrap v-for="(filter, index) in rangeFilters", :key="index" justify="start" no-gutters)
                  v-flex(xs3)
                    label(style="margin-left: 10px;") {{ filter.filterFrom.name }}
                    v-text-field(
                      class="ma-3"
                      outlined
                      dense
                      hide-details
                      v-model="filters.items[filter.filterFrom.key]"
                      placeholder="от")
                  v-flex(xs3)
                    label(style="margin-left: 10px;") &nbsp;
                    v-text-field(
                      class="ma-3"
                      outlined
                      dense
                      hide-details
                      v-model="filters.items[filter.filterTo.key]"
                      placeholder="до")
              div(v-if="isShow").advanced-filters
                v-container(class="pb-0")
                  v-row(wrap v-if="dynamicFilters.length")
                    v-flex(xs3
                      v-if="filter.type !== 'bool'",
                      v-for="(filter, index) in dynamicFilters",
                      :key="index")
                      v-select(
                        outlined
                        dense
                        hide-details
                        style="margin: 10px 10px;",
                        v-model="filters.items[filter.key]"
                        v-if="filter.type === 'enum'",
                        :items="filter.enumValues",
                        item-value="key",
                        :placeholder="filter.name")
                  v-layout(row, v-if="dynamicFilters.length" style="padding: 0 10px;")
                    v-flex(xs4
                      v-if="filter.type === 'bool'",
                      v-for="(filter, index) in dynamicFilters",
                      :key="index")
                      v-switch(
                        v-model="filters.items[filter.key]"
                        color="#FFD54F",
                        v-if="filter.type === 'bool'"
                        :label="filter.name")
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    filters: {},
    isShow: false,
    type: 'rent',
    commerceTypes: [
      {
        key: 'rentOther',
        text: 'Аренда'
      },
      {
        key: 'sellOther',
        text: 'Продажа'
      }
    ],
    commerce: 'rentOther',
    advertType: {
      SALE: 'sale',
      RENT: 'rent',
      NEW: 'new',
      COMMERCE: 'commerce',
      IK: 'ik'
    },
    buildingType: {
      APARTMENT: 'apartment',
      ROOM: 'room',
      HOUSE: 'house',
      AREA: 'area',
      OTHER: 'other'
    }
  }),
  created() {
    this.$store.dispatch('GET_CITY_LIST')
    this.filters = Object.assign({}, this.baseFilters)
    this.showAdverts()
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.filters = Object.assign({}, this.baseFilters)
        this.showAdverts()
      }
    },
    filters: {
      deep: true,
      handler(values) {
        const filters = JSON.parse(localStorage.filters)
        filters.advertType = this.setAdvertsType(values.items.Type)
        filters.items = values.items
        this.$store.dispatch('GET_ADVERTS_FILTER_COUNT', filters)
        localStorage.filters = JSON.stringify(filters)
      }
    },
    'filters.items.Type': {
      deep: true,
      handler(value) {
        const filters = JSON.parse(localStorage.filters)
        filters.advertType = this.setAdvertsType(value)
        this.$store.dispatch('GET_DINAMIC_FILTERS', filters.advertType)
        localStorage.filters = JSON.stringify(filters)
      }
    },
    'filters.items.CityId': {
      deep: true,
      async handler(cityId) {
        if (cityId) {
          const filters = JSON.parse(localStorage.filters)
          filters.items.CityId = cityId
          localStorage.filters = JSON.stringify(filters)
          if (this.cityList.length) {
            const result = await this.cityList.filter(
              item => item.id === cityId
            )[0]
            if (result.data) {
              this.$store.commit('SET_COORDINATION', JSON.parse(result.data))
            }
          }
          await this.$store.dispatch('GET_DISTRICT_LIST', cityId)
        }
      }
    },
    commerce(val) {
      const filters = {}
      filters.advertType = val
      filters.items = this.filters.items
      this.$store.dispatch('GET_ADVERTS_FILTER_COUNT', filters)
      localStorage.filters = JSON.stringify(filters)
    }
  },
  computed: {
    ...mapState({
      countAdverts: state => state.countAdverts,
      districtList: state => state.districtList,
      currencyList: state => state.currencyList,
      baseFilters: state => state.baseFilters,
      dynamicFilters: state => state.dynamicFilters,
      rangeFilters: state => state.rangeFilters,
      cityList: state => state.cityList,
      getAdvertLoading: state => state.loading.getAdvertsList
    }),
    typeTitle() {
      let buildType = ''
      let cityName = ''
      let type = ''
      switch (this.$route.params.type) {
        case 'rent':
          type = 'Аренда'
          break
        case 'sale':
          type = 'Продажа'
          break
        case 'commerce':
          type = 'Коммерческая недвижимость'
          break
        case 'new':
          type = 'Новая недвижимость'
          break
        case 'ik':
          type = 'Недвижимость на Иссык-Куле'
      }
      switch (this.filters.items.Type) {
        case this.buildingType.APARTMENT:
          this.type === this.advertType.NEW || this.type === this.advertType.IK
            ? (buildType = 'квартиры')
            : (buildType = 'квартир')
          break
        case this.buildingType.ROOM:
          this.type === this.advertType.NEW || this.type === this.advertType.IK
            ? (buildType = 'комнаты')
            : (buildType = 'комнат')
          break
        case this.buildingType.HOUSE:
          this.type === this.advertType.NEW || this.type === this.advertType.IK
            ? (buildType = 'дома')
            : (buildType = 'домов')
          break
        case this.buildingType.AREA:
          buildType = 'участков'
          this.type === this.advertType.NEW || this.type === this.advertType.IK
            ? (buildType = 'участки')
            : (buildType = 'участков')
          break
      }
      return `${type} ${buildType} ${cityName}`
    },
    buildingTypes() {
      const types = [
        {
          text: 'Квартира',
          value: 'apartment'
        },
        {
          text: 'Комната',
          value: 'room'
        },
        {
          text: 'Дом',
          value: 'house'
        },
        {
          text: 'Участок',
          value: 'area'
        },
        {
          text: 'Другое',
          value: 'other'
        }
      ]
      let result = null

      if (this.type === this.advertType.RENT) {
        result = null
        result = types
      }
      if (this.type === this.advertType.NEW) {
        result = [
          {
            text: 'Квартира',
            value: 'apartment'
          },
          {
            text: 'Дом',
            value: 'house'
          }
        ]
      }
      if (this.type === this.advertType.SALE) {
        result = null
        types.splice(1, 1)
        result = types
      }
      if (this.type === this.advertType.IK) {
        result = null
        types.splice(3, 1)
        result = types
      }
      return result
    },
    display: {
      get() {
        return this.$store.state.viewType
      },
      async set(value) {
        await this.$store.commit('SET_VIEW_TYPE', value)
        this.getAdvertList(value)
      }
    }
  },
  methods: {
    setRouteType() {
      delete this.filters.items.AllComplex
      this.filters.items.Commerce = false
      this.type = 'rent'
      switch (this.$route.params.type) {
        case 'commerce':
          this.type = this.advertType.COMMERCE
          this.filters.items.Type = this.buildingType.OTHER
          this.filters.items.Commerce = true
          break
        case 'new':
          this.type = this.advertType.NEW
          this.filters.items.AllComplex = true
          break
        case 'rent':
          this.type = this.advertType.RENT
          break
        case 'sale':
          this.type = this.advertType.SALE
          break
        case 'ik':
          this.type = this.advertType.IK
      }
      this.filters.advertType = this.setAdvertsType(this.filters.items.Type)
      // localStorage.filters = JSON.stringify(this.filters)
    },
    setAdvertsType(value) {
      if (this.type === this.advertType.COMMERCE) return this.commerce
      if (
        this.type === this.advertType.RENT ||
        this.type === this.advertType.NEW ||
        this.type === this.advertType.IK
      ) {
        switch (value) {
          case 'apartment':
            return 'RentApartment'
          case 'room':
            return 'RentRoom'
          case 'house':
            return 'RentHouse'
          case 'area':
            return 'RentArea'
          case 'other':
            return 'RentOther'
        }
      }
      if (this.type === this.advertType.SALE) {
        switch (value) {
          case 'apartment':
            return 'SellApartment'
          case 'room':
            return 'SellRoom'
          case 'house':
            return 'SellHouse'
          case 'area':
            return 'SellArea'
          case 'other':
            return 'SellOther'
        }
      }
    },
    setFilters() {
      let filters = JSON.parse(localStorage.filters)
      filters = this.filters
      filters.advertType = this.setAdvertsType(filters.items.Type)
      this.$route.params.type === 'ik'
        ? (filters.items.CityId = 2)
        : (filters.items.CityId = 1)
      localStorage.filters = JSON.stringify(filters)
    },
    getAdvertList(type) {
      if (type === 'list') {
        this.$store.dispatch('GET_ADVERTS_LIST', 0)
      } else {
        this.$store.dispatch('GET_ADVERTS_LIST', -1)
      }
    },
    async showAdverts() {
      this.isShow = false
      await this.setRouteType()
      await this.setFilters()
      this.getAdvertList(this.display)
    },
    isRoomsCountDisplay() {
      if (
        (this.type === this.advertType.RENT &&
          this.buildingType.APARTMENT === this.filters.items.Type) ||
        (this.type === this.advertType.SALE &&
          this.buildingType.APARTMENT === this.filters.items.Type) ||
        (this.type === this.advertType.NEW &&
          this.buildingType.APARTMENT === this.filters.items.Type)
      ) {
        return true
      } else {
        delete this.filters.items.RoomCount
      }
    },
    isDurationRentDisplay() {
      if (
        this.type === this.advertType.RENT ||
        (this.type === this.advertType.COMMERCE &&
          this.commerce === 'rentOther')
      ) {
        return true
      } else {
        delete this.filters.items.DurationRent
      }
    },
    isDescriptionDisplay() {
      if (this.type === this.advertType.COMMERCE) {
        return true
      } else {
        delete this.filters.items.description
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.duration {
  .v-btn {
    background-color: #fff !important;
    color: #8e8e93;
    &--active {
      background-color: #b39ddb !important;
      color: #fff;
      &:before {
        display: none;
      }
    }
  }
}
.toggleBtn {
  cursor: pointer;
  color: #3d5afe;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.072px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s ease;
}
</style>
